import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { correoService } from '../services/correoService';
import { FiltrosCorreos } from '../types/correo';

/** Bitácora de correos. `keepPreviousData` evita el parpadeo al cambiar de página. */
export function useCorreos(filtros: FiltrosCorreos) {
  return useQuery({
    queryKey: ['correos', filtros],
    queryFn: () => correoService.list(filtros),
    placeholderData: keepPreviousData,
  });
}

export function useOpcionesCorreos() {
  return useQuery({ queryKey: ['correos-opciones'], queryFn: correoService.opciones });
}

/** Al enviar, la bitácora queda vieja: se refresca para que el correo recién salido aparezca. */
export function useNotificarEstudiantes() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: correoService.notificarEstudiantes,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['correos'] });
      qc.invalidateQueries({ queryKey: ['correos-opciones'] });
    },
  });
}
